import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material'
import I18n from 'i18n-js'
import { useState } from 'react'
import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  AlertMenu,
  CrudsBtn,
  LanguageSelector,
  SearchBar,
} from '../../components'
import { AuthContext } from '../../context/auth'
import { canAccess } from '../../router/permissions'
import { parameter } from '../../services'
import {
  actionKeys,
  Icons,
  languages,
  pagesKeys,
  rowsPerPage,
} from '../../utils'
import useStyles from '../crudsStyles'
import { ModalParameters } from './components/modal'
import { parametersTypes } from './components/modal/contants'

const Parameter = () => {
  const { state } = useContext(AuthContext)
  const history = useHistory()
  const pageId = pagesKeys.parameter
  const [page, setPage] = useState(0)
  const classes = useStyles()
  const [search, setSearch] = useState('')
  const [deleteItem, setDeleteItem] = useState()
  const [openModal, setOpenModal] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [create, setCreate] = useState(true)
  const [languageColOne, setLanguageColOne] = useState(languages[0].locale)
  const [languageColTwo, setLenguageColTwo] = useState(languages[1].locale)
  const [data, setData] = useState([])
  const [anchor, setAnchor] = useState(null)
  const [editItem, seteditItem] = useState({})
  const [loadButton, setLoadButton] = useState(false)
  const [items, setItems] = useState([])
  const [editId, setEditId] = useState()
  const [successDelete, setSuccessDelete] = useState('')

  const getData = async () => {
    const res = await parameter.list()

    setData(res.data?.parameters)
    setItems(res.data?.parameters)
  }

  const handleChangeLenguaje1 = (e) => {
    setLanguageColOne(e.target.value)
  }
  const handleChangeLenguaje2 = (e) => {
    setLenguageColTwo(e.target.value)
  }

  const handleChangeSearchbar = (e) => {
    setSearch(e.target.value)
  }
  const openLink = (value) => window.open(value)

  const handleData = ({ data, type }) => {
    let form
    const isFile = type == parametersTypes.file
    if (isFile) {
      form = new FormData()
      form.append('type', type)
      form.append('key', data.key)
    } else {
      form = {
        type: type,
        key: data.key,
        value: [],
      }
    }
    languages.forEach((item, index) => {
      if (data[item.locale]) {
        if (isFile) {
          form.append(`value[${index}][locale]`, item.locale)
          form.append(
            `value[${index}][value]`,
            data[item.locale]?.type ? data[item.locale] : ''
          )
        } else {
          form = {
            ...form,
            value: [
              ...form.value,
              {
                locale: item.locale,
                value: data[item.locale]?.replaceAll('\n', '').trim() ?? '',
              },
            ],
          }
        }
      }
    })

    return form
  }
  
  const submit = async (payload) => {
    // setLoadButton(true)
    let form = handleData({data: payload.data, type: payload.type})
    
    if(!create) {
      form = {
        id: editId,
        update: form,
      }
    }
    const response = await parameter?.[create ? 'create' : 'edit'](form, payload.type === parametersTypes.file)
    if (response.data) {
      setSuccessDelete(I18n.t(`components.${create ? "alert" : "alertEdit"}`))
      payload.successSend(true)
      closeModal()
      getData()
    } else {
      payload.successSend(false)
      setSuccessDelete(I18n.t('components.deleteError'))
    }
    setLoadButton(false)
  }
  
  const openModalForm = (_, data = null) => {
    if (data != null) {
      const oldValues = {
        key: data.key,
        type: data.type
      }
      languages.map((language) => {
        oldValues[language.locale] = data.translations.find(
          (lang) => lang.locale == language.locale
        )?.value
      })
      
      setEditId(data.id)
      seteditItem(oldValues)

      setCreate(false)
    } else {
      setCreate(true)
    }
    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
    seteditItem({})
  }

  const handleDeleteClick = (e) => {
    setAnchor(e.currentTarget)
  }

  const handleDeleteClose = () => {
    setAnchor(null)
  }

  const handleDeleteItem = async () => {
    const response = await parameter.destroy(deleteItem)
    setAnchor(null)
    getData()
    setSearch('')
    document.getElementById('search').value = ''
    setShowAlert(true)
    if (response.data) setSuccessDelete(I18n.t('components.alertDelete'))
    else setSuccessDelete(I18n.t('components.deleteError'))
  }

  const searchItems = () => {
    if (search?.trim() != '') {
      const filter = data?.filter((e) =>
        e.key.toLowerCase().includes(search.toLowerCase())
      )

      filter != ''
        ? setItems(filter)
        : setItems([{ error: I18n.t('general.notFound') }])
    } else {
      setItems(data)
    }
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  useEffect(() => {
    if (!canAccess(actionKeys.view, pageId, state)) {
      history.push('/dashboard')
    } else {
      getData()
    }
  }, [])

  useEffect(searchItems, [search])

  return (
    <Box p={4} m={4}>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        wrap="nowrap"
      >
        <Grid item className={classes.items}>
          <Typography variant="body2" color="textSecondary">
            {I18n.t('breadcrumb.parameter')} / {I18n.t('breadcrumb.dashboard')}
          </Typography>
        </Grid>
        <Grid item className={classes.itemFlex}>
          <Typography variant="h5" color="primary" className={classes.title}>
            {I18n.t('breadcrumb.parameter')}
          </Typography>
          {canAccess(actionKeys.list, pageId, state) && (
            <Hidden mdDown>
              <div className={classes.search}>
                <SearchBar
                  change={handleChangeSearchbar}
                  search={searchItems}
                />
              </div>
            </Hidden>
          )}

          {canAccess(actionKeys.create, pageId, state) && (
            <CrudsBtn
              text={I18n.t('cruds.parameter.button')}
              size="medium"
              click={openModalForm}
            />
          )}

          {canAccess(actionKeys.list, pageId, state) && (
            <Hidden mdUp>
              <Grid item xs={12} className={classes.items}>
                <SearchBar
                  change={handleChangeSearchbar}
                  search={searchItems}
                />
              </Grid>
            </Hidden>
          )}
        </Grid>
        {canAccess(actionKeys.list, pageId, state) && (
          <Grid item className={classes.items}>
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table} size="small">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell align="left" className={classes.tableCell}>
                      <LanguageSelector
                        change={handleChangeLenguaje1}
                        language={languageColOne}
                        languages={languages}
                      />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <LanguageSelector
                        change={handleChangeLenguaje2}
                        language={languageColTwo}
                        languages={languages}
                      />
                    </TableCell>
                    {(canAccess(actionKeys.edit, pageId, state) ||
                      canAccess(actionKeys.delete, pageId, state)) && (
                      <TableCell align="center">
                        <Typography variant="body1" color="textPrimary">
                          {I18n.t('general.actions')}
                        </Typography>
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {items?.length > 0 && (
                  <TableBody>
                    {(rowsPerPage.parameter > 0
                      ? items?.slice(
                          page * rowsPerPage.parameter,
                          page * rowsPerPage.parameter + rowsPerPage.parameter
                        )
                      : items
                    )?.map((item, index) => {
                      const { translations, key, type } = item
                      const localeOne = translations.find(
                        (lang) => lang.locale == languageColOne
                      )?.value
                      const localeTwo = translations.find(
                        (lang) => lang.locale == languageColTwo
                      )?.value
                      if (item.error) {
                        return (
                          <TableRow className={classes.tableRow} key={index}>
                            <TableCell align="left" colSpan={4}>
                              <Typography variant="h6" color="primary">
                                {item.error}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )
                      } else {
                        return (
                          !item.error && (
                            <TableRow className={classes.tableRow} key={index}>
                              <TableCell className={classes.tableCell}>
                                <Typography variant="body2" color="textPrimary">
                                  {I18n.t('cruds.parameter.key')}: {key}
                                </Typography>
                                <Box className={classes.alignItemsCenter}>
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    {I18n.t('cruds.parameter.value')}:
                                    {` (${I18n.t(`cruds.parameter.${type}`)}) `}
                                    {type === 'text' && localeOne}
                                  </Typography>
                                  {[parametersTypes.file].includes(type) && (
                                    <IconButton
                                      className={classes.show}
                                      onClick={() => {
                                        openLink(localeOne)
                                      }}
                                    >
                                      {Icons('show')}
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <Typography variant="body2" color="textPrimary">
                                  {I18n.t('cruds.parameter.key')}: {key}
                                </Typography>

                                <Box className={classes.alignItemsCenter}>
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    {I18n.t('cruds.parameter.value')}:
                                    {` (${I18n.t(`cruds.parameter.${type}`)}) `}
                                    {type === 'text' && localeTwo}
                                  </Typography>
                                  {[parametersTypes.file].includes(type) && localeTwo && (
                                    <IconButton
                                      className={classes.show}
                                      onClick={() => {
                                        openLink(localeTwo)
                                      }}
                                    >
                                      {Icons('show')}
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                              {(canAccess(actionKeys.edit, pageId, state) ||
                                canAccess(
                                  actionKeys.delete,
                                  pageId,
                                  state
                                )) && (
                                <TableCell
                                  align="right"
                                  className={classes.tableCellActions}
                                >
                                  <div className={classes.divactions}>
                                    {canAccess(
                                      actionKeys.edit,
                                      pageId,
                                      state
                                    ) && (
                                      <IconButton
                                        color="secondary"
                                        onClick={(e) => {
                                          openModalForm(e, item)
                                        }}
                                      >
                                        {Icons('edit')}
                                      </IconButton>
                                    )}

                                    {canAccess(
                                      actionKeys.delete,
                                      pageId,
                                      state
                                    ) && (
                                      <IconButton
                                        className={classes.delete}
                                        onClick={(e) => {
                                          handleDeleteClick(e)
                                          setDeleteItem(item.id)
                                        }}
                                      >
                                        {Icons('delete')}
                                      </IconButton>
                                    )}
                                  </div>
                                </TableCell>
                              )}
                            </TableRow>
                          )
                        )
                      }
                    })}
                    <tr>
                      <TablePagination
                        rowsPerPageOptions={[rowsPerPage.parameter]}
                        count={items && items?.length}
                        page={page}
                        rowsPerPage={rowsPerPage.parameter}
                        onPageChange={handleChangePage}
                        className={classes.pagination}
                      />
                    </tr>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Grid>

      <ModalParameters
        open={openModal}
        onClose={closeModal}
        loadButton={loadButton}
        isUpdate={!create}
        submit={submit}
        defaultValue={editItem}
      />
      
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showAlert}
        autoHideDuration={2000}
        onClose={() => {
          setShowAlert(false)
          setSuccessDelete('')
        }}
        className={classes.alert}
      >
        <Alert severity="success">{successDelete}</Alert>
      </Snackbar>

      <AlertMenu
        anchor={anchor}
        close={handleDeleteClose}
        action={handleDeleteItem}
      />

      {items == '' && (
        <div className={classes.loadingBg}>
          <CircularProgress color="primary" className={classes.loading} />{' '}
        </div>
      )}
    </Box>
  )
}

export default Parameter
